import { createApp } from 'vue'
import App from './App.vue'
import { createAppRouter } from './router'
import './styles/index.scss'
import LoanproUI from 'loanpro-ui'
import 'loanpro-ui/dist/style.css'
import { injectDependencies } from './injectDependencies'
import { loadConfig, useConfigSync } from '@/config/useConfig'

/**
 * We load this asynchronusly because some components
 * are dependant on the config that is loaded asynchronously
 * If you reload (F5) a view that is dependant on the config the view will load before
 * the config is loaded leading to unexpected behaviours.
 */

const loadLookNFeel = () => {
  const config = useConfigSync()
  const logo = config?.looknfeel?.login_logo
  const iconLight = document.getElementById('icon-light') as HTMLLinkElement
  const iconDark = document.getElementById('icon-dark') as HTMLLinkElement
  const tittle = document.getElementById('title') as HTMLTitleElement

  switch (logo) {
    case 'pismo':
      tittle.text = 'Pismo'
      iconLight.href = `.${process.env.BASE_URL}pismo-favicon.ico`
      iconDark.href = `.${process.env.BASE_URL}pismo-favicon.ico`
      break
    case 'galileo':
      tittle.text = 'Galileo'
      iconLight.href = `.${process.env.BASE_URL}galileo-favicon.svg`
      iconDark.href = `.${process.env.BASE_URL}galileo-favicon-white.svg`
      break
    case 'mastercard':
      tittle.text = 'Mastercard'
      iconLight.href = `.${process.env.BASE_URL}mastercard-favicon.ico`
      iconDark.href = `.${process.env.BASE_URL}mastercard-favicon.ico`
      break
    default:
      tittle.text = 'LoanPro'
      iconLight.href = `.${process.env.BASE_URL}favicon-dark.ico`
      iconDark.href = `.${process.env.BASE_URL}favicon-light.ico`
  }
}

(async () => {
  await loadConfig()
  loadLookNFeel()
  const app = createApp(App)
  const router = await createAppRouter()
  injectDependencies(app, router)
  app.use(router)
  app.use(LoanproUI)
  app.mount('#app')
})()
